"use strict";
/// <reference path="tornado-data-preparer.ts" />
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
exports.__esModule = true;
var tornado_data_preparer_1 = require("./tornado-data-preparer");
var TornadoChartMaker = /** @class */ (function () {
    function TornadoChartMaker(inputData, shadowInputData, shadowNodeName, nodeName, maxBars, showTooltip, decimals, timestamp) {
        this.dataPreparer = new tornado_data_preparer_1["default"](inputData, shadowInputData, shadowNodeName, nodeName, maxBars);
        this.showTooltip = showTooltip;
        this.decimals = decimals;
        this.timestamp = timestamp;
    }
    TornadoChartMaker.prototype.plot = function () {
        this.initialize();
        this.draw();
    };
    TornadoChartMaker.prototype.initialize = function () {
        this.color = this.dataPreparer.inputData.Colors.mainColor;
        if (this.dataPreparer.shadowInputData) {
            this.shadowColor = this.dataPreparer.shadowInputData.Colors.shadowColor;
        }
        this.units = this.dataPreparer.units();
        this.chartTitle = this.dataPreparer.chartTitle();
        this.outputTitle = this.dataPreparer.outputTitle();
    };
    TornadoChartMaker.prototype.getDate = function () {
        return this.dataPreparer.getDate();
    };
    TornadoChartMaker.prototype.toCsv = function () {
        return this.dataPreparer.toCsv();
    };
    TornadoChartMaker.prototype.makeFactors = function () {
        return this.dataPreparer.makeFactors();
    };
    TornadoChartMaker.prototype.mapShadowTableToTable = function () {
        return this.dataPreparer.mapShadowTableToTable();
    };
    TornadoChartMaker.prototype.makeTableData = function (decimalsInTable) {
        return this.dataPreparer.makeTableData(decimalsInTable);
    };
    TornadoChartMaker.prototype.findChartHeight = function (factors, x) {
        if (factors.length <= 5) {
            var chartHeight = 300 + (x * x);
        }
        else if (factors.length <= 10) {
            var chartHeight = 400 + (x * x);
        }
        else {
            var chartHeight = factors.length * (40 + x);
        }
        return chartHeight;
    };
    TornadoChartMaker.prototype.draw = function () {
        var factors = this.makeFactors();
        var lowData = this.dataPreparer.makeData(3, 0, 0);
        var highData = this.dataPreparer.makeData(5, 2, 2);
        var minMaxRange = {};
        if (this.dataPreparer.summary[0] == this.dataPreparer.summary[1] &&
            this.dataPreparer.summary[0] == this.dataPreparer.summary[2]) {
            minMaxRange = { "min": this.dataPreparer.summary[0] / 2, "max": this.dataPreparer.summary[0] * 1.5 };
        }
        if (this.dataPreparer.shadowInputData) {
            var lowShadowData = this.dataPreparer.makeShadowData(3, 0, 0);
            var highShadowData = this.dataPreparer.makeShadowData(5, 2, 2);
        }
        var series = [];
        var seriesLowData = this.dataPreparer.makeSeries(3, 0, 0);
        var seriesHighData = this.dataPreparer.makeSeries(5, 2, 2, true);
        series = series.concat(seriesLowData, seriesHighData);
        var verticalLine = this.dataPreparer.makeVerticalLine(this.dataPreparer.nodeName, this.color, this.dataPreparer.baseValue, -0.2, 0);
        series = series.concat(verticalLine);
        if (this.dataPreparer.shadowInputData) {
            var seriesLowShadowData = this.dataPreparer.makeShadowSeries(3, 0, 0);
            var seriesHighShadowData = this.dataPreparer.makeShadowSeries(5, 2, 2, true);
            series = series.concat(seriesLowShadowData, seriesHighShadowData);
            var shadowVerticalLine = this.dataPreparer.makeVerticalLine(this.dataPreparer.shadowNodeName, this.shadowColor, this.dataPreparer.shadowBaseValue, 0.30, 0.50);
            series = series.concat(shadowVerticalLine);
        }
        if (!this.dataPreparer.shadowInputData) {
            var chartHeight = this.findChartHeight(factors, 0);
        }
        else {
            var chartHeight = this.findChartHeight(factors, 10);
        }
        var chartMaker = this;
        var chart = new Highcharts.Chart({
            chart: {
                renderTo: 'tornadoChartContainer',
                width: 900,
                height: chartHeight,
                zoomType: 'xy',
                marginRight: 50
            },
            credits: {
                enabled: false
            },
            exporting: {},
            legend: {},
            title: {
                text: chartMaker.chartTitle
            },
            tooltip: {
                enabled: chartMaker.showTooltip,
                formatter: function () {
                    var msg = "";
                    if (!this.point.noTooltip) {
                        if (typeof this.x == "number") {
                            if ((this.x % 0.5) != 0.25 && this.x >= 0) {
                                var shadowIndex = Math.floor(this.x);
                                var shadowLow = chartMaker.dataPreparer.noOfDecimals(lowShadowData[shadowIndex].y, chartMaker.decimals);
                                var shadowHigh = chartMaker.dataPreparer.noOfDecimals(highShadowData[shadowIndex].y, chartMaker.decimals);
                                if (isNaN(shadowLow)) {
                                    msg = "Shadow Base case value: " + chartMaker.dataPreparer.shadowBaseValue;
                                    return msg;
                                }
                                this.x = factors[shadowIndex];
                                if (this.x === chartMaker.dataPreparer.combinedTitle || this.x === chartMaker.dataPreparer.combinedTitle + "-" + chartMaker.dataPreparer.shadowNodeName) {
                                    msg = chartMaker.dataPreparer.combinedTitle + " for " + chartMaker.outputTitle + ": " + shadowLow + " to " + shadowHigh;
                                }
                                else {
                                    var shadowLowLabel = chartMaker.dataPreparer.noOfDecimals(lowShadowData[shadowIndex].label, chartMaker.decimals);
                                    var shadowHighLabel = chartMaker.dataPreparer.noOfDecimals(highShadowData[shadowIndex].label, chartMaker.decimals);
                                    msg = '<b>' + chartMaker.outputTitle + '</b> goes from ' + shadowLow + ' to ' + shadowHigh + '<br/> when ' + this.series.chart.xAxis[0].categories[shadowIndex] +
                                        ' goes from ' + shadowLowLabel + " to " + shadowHighLabel;
                                }
                                return msg;
                            }
                        }
                        else {
                            var index = this.series.chart.xAxis[0].categories.indexOf(this.x);
                            var low = chartMaker.dataPreparer.noOfDecimals(lowData[index].y, chartMaker.decimals);
                            var high = chartMaker.dataPreparer.noOfDecimals(highData[index].y, chartMaker.decimals);
                            if (isNaN(low)) {
                                msg = "Base case value: " + chartMaker.dataPreparer.baseValue;
                                return msg;
                            }
                            if (this.x === chartMaker.dataPreparer.combinedTitle || this.x === chartMaker.dataPreparer.combinedTitle + "-" + chartMaker.dataPreparer.shadowNodeName) {
                                msg = chartMaker.dataPreparer.combinedTitle + " for " + chartMaker.outputTitle + ": " + low + " to " + high;
                            }
                            else {
                                var lowLabel = chartMaker.dataPreparer.noOfDecimals(lowData[index].label, chartMaker.decimals);
                                var highLabel = chartMaker.dataPreparer.noOfDecimals(highData[index].label, chartMaker.decimals);
                                msg = '<b>' + chartMaker.outputTitle + '</b> goes from ' + low + ' to ' + high + '<br/> when ' + this.x +
                                    ' goes from ' + lowLabel + " to " + highLabel;
                            }
                            return msg;
                        }
                    }
                    return false;
                }
            },
            plotOptions: {
                series: {
                    pointWidth: 15,
                    dataLabels: {
                        enabled: true,
                        crop: false,
                        overflow: 'none',
                        allowOverlap: true,
                        style: {
                            fontWeight: 'thin'
                        },
                        formatter: function () {
                            if (typeof this.x == "number") {
                                if ((this.x % 0.5) != 0.25) {
                                    var shadowIndex = Math.floor(this.x);
                                    if (shadowIndex >= 0) {
                                        this.key = factors[shadowIndex];
                                        if (this.y == lowShadowData[shadowIndex].y) {
                                            if (typeof lowShadowData[shadowIndex].label == 'number') {
                                                return this.key === chartMaker.dataPreparer.combinedTitle ? "" : chartMaker.dataPreparer.noOfDecimals(lowShadowData[shadowIndex].label, chartMaker.decimals);
                                            }
                                            else {
                                                return this.key === chartMaker.dataPreparer.combinedTitle ? "" : lowShadowData[shadowIndex].label;
                                            }
                                        }
                                        if (this.y == highShadowData[shadowIndex].y) {
                                            if (typeof highShadowData[shadowIndex].label == 'number') {
                                                return this.key === chartMaker.dataPreparer.combinedTitle ? "" : chartMaker.dataPreparer.noOfDecimals(highShadowData[shadowIndex].label, chartMaker.decimals);
                                            }
                                            else {
                                                return this.key === chartMaker.dataPreparer.combinedTitle ? "" : highShadowData[shadowIndex].label;
                                            }
                                        }
                                    }
                                }
                            }
                            else {
                                var index = this.series.chart.xAxis[0].categories.indexOf(this.x);
                                this.key = factors[index];
                                if (this.y == lowData[index].y) {
                                    if (typeof lowData[index].label == 'number') {
                                        return this.key === chartMaker.dataPreparer.combinedTitle ? "" : chartMaker.dataPreparer.noOfDecimals(lowData[index].label, chartMaker.decimals);
                                    }
                                    else {
                                        return this.key === chartMaker.dataPreparer.combinedTitle ? "" : lowData[index].label;
                                    }
                                }
                                if (this.y == highData[index].y) {
                                    if (typeof highData[index].label == 'number') {
                                        return this.key === chartMaker.dataPreparer.combinedTitle ? "" : chartMaker.dataPreparer.noOfDecimals(highData[index].label, chartMaker.decimals);
                                    }
                                    else {
                                        return this.key === chartMaker.dataPreparer.combinedTitle ? "" : highData[index].label;
                                    }
                                }
                            }
                        }
                    }
                }
            },
            xAxis: {
                title: {
                    text: 'Factor'
                },
                allowDecimals: false,
                categories: factors,
                labels: {
                    formatter: function () {
                        if (typeof this.value === "string" && this.value.indexOf(chartMaker.dataPreparer.shadowNodeName) !== -1) {
                            return "";
                        }
                        return this.value;
                    }
                }
            },
            yAxis: [__assign(__assign({ title: {
                        text: this.outputTitle + " (" + this.units + ")"
                    } }, minMaxRange), { opposite: true })],
            series: series
        }, function (chart) {
            chart.renderer.text(chartMaker.dataPreparer.getDate(chartMaker.timestamp), 700, chartHeight - 2)
                .css({
                color: '#939294',
                fontSize: '10px'
            })
                .add();
        });
    };
    return TornadoChartMaker;
}());
exports["default"] = TornadoChartMaker;
//# sourceMappingURL=tornado-chart-maker.js.map


// WEBPACK FOOTER //
// ./app/widgets/action/tornado/app/js/logic/tornado-chart-maker.js